import { find, method, some } from "lodash";

// redirects configs
const redirects: any[] = [
	{
		role: "NormalRole",
		redirect: '/list/invoice'
	},
	{
		role: "SuperAdminRole",
		redirect: '/admin/dashboard'
	},
	{
		role: "AccountantRole",
		redirect: '/dashboard'
	}
];


export const searchRoleRedirect = (role: string): string | null => {
	return find(redirects, { "role": role })?.redirect || '/dashboard';
}

export const checkScopes = (routeScopes: Array<string>, userScopes: Array<string>): boolean => {
	if (routeScopes && userScopes) {
		let canRender = false;

		if (some(routeScopes, method('includes', '*')) || some(userScopes, method('includes', '*')))
			return true;

		userScopes.map(function (item: string) {
			const searchResult = some(routeScopes, method('includes', item));
			if (searchResult)
				canRender = searchResult;
		});

		return canRender;
	}

	// no vienen seteados los params asi que damos por hecho que es solo auth
	return true;
}
